import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";

const signupSlice = createSlice({
  name: "signup",
  initialState: {
    page: 0,
    rowsPerPage: 10,
    totalAccounts: 0,
    data: [],
    filters: {},
    loading: false,
    error: null,
  },

  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    requestSuccess: (state, action) => {
      state.data = action.payload.accounts;
      state.totalAccounts = action.payload.totalAccounts;
      state.loading = false;
      state.error = null;
    },
    addNewAccount: (state, action) => {
      state.data.unshift(action.payload);
      state.data.pop();
    },
    updateAccount: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    deleteAccount: (state, action) => {
      state.data = state.data.filter((r) => r._id !== action.payload.id);
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetSignupState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  requestStart,
  requestSuccess,
  requestFailure,
  resetSignupState,
  setFilters,
  setPage,
  setRowsPerPage,
  addNewAccount,
  updateAccount,
  deleteAccount,
} = signupSlice.actions;

export default signupSlice.reducer;

export const CreateUserAccount = (data) => async (dispatch) => {
  try {
    const response = await axios.post("/private/backend/createuser", data);
    if (response?.status === 201) {
      const data = response.data;
      console.log(data);
      dispatch(addNewAccount(data));
      toast.success("Account created successfully!");
    }
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || "Account creation failed!"
    );
    return null;
  }
};

export const GetUserAccounts = (page, limit, filters) => async (dispatch) => {
  try {
    dispatch(requestStart());

    const response = await axios.get(
      `/private/backend/createuser?${generateQueryParams({
        ...filters,
        page,
        limit,
      })}`
    );
    if (response?.status === 200) {
      const data = response.data;
      dispatch(requestSuccess(data));
    }
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || "Account creation failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};
export const UpdateUserAccountSlice = (data) => async (dispatch) => {
  try {
    const response = await axios.put("/private/backend/createuser", data);

    if (response?.data) {
      const data = response.data;
      // dispatch(GetUserAccounts());
      dispatch(updateAccount(data));
      toast.success("Customer Account Updated!");
    }
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || "Account creation failed!"
    );
  }
};

export const DeleteUserAccountSlice = (data) => async (dispatch) => {
  try {
    const response = await axios.delete("/private/backend/createuser", {
      data,
    });

    if (response?.data) {
      // dispatch(deleteAccount(data));
      toast.success("Account has been Deleted!");
    }
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || "Account creation failed!"
    );
    // dispatch(
    //   signupFailure(err?.response?.data?.message || "Something went wrong!")
    // );
    return null;
  }
};
